export enum QueryKeysEnum {
  StartFromId = 'startFromId',
  Order = 'order',
  Limit = 'limit',
  Filter = 'filter',
  SortColumn = 'sortColumn',
  SortDirection = 'sortDirection',
}
